import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "jwt-container"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "title"
}, "JWT 加密/解密工具", -1);
const _hoisted_3 = {
  class: "section"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "编码区域", -1);
const _hoisted_5 = {
  class: "section control-section"
};
const _hoisted_6 = {
  class: "algorithm-select"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "签名算法：", -1);
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", null, "HS256", -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", null, "HS384", -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", null, "HS512", -1);
const _hoisted_11 = [_hoisted_8, _hoisted_9, _hoisted_10];
const _hoisted_12 = {
  class: "section"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", null, "解码结果", -1);
const _hoisted_14 = {
  class: "decode-result"
};
const _hoisted_15 = {
  class: "result-part"
};
const _hoisted_16 = {
  class: "result-header"
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", null, "头部/Header", -1);
const _hoisted_18 = {
  class: "action-buttons"
};
const _hoisted_19 = {
  class: "result-part"
};
const _hoisted_20 = {
  class: "result-header"
};
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "载荷/Payload", -1);
const _hoisted_22 = {
  class: "action-buttons"
};
const _hoisted_23 = {
  class: "secret-input"
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h3", null, "对称密钥", -1);
import { ref, computed } from 'vue';
import { jwtDecode } from 'jwt-decode';
import { SignJWT } from 'jose';
// import {
//   Grid,
//   CopyDocument
// } from '@element-plus/icons-vue';

export default {
  __name: 'jwt',
  setup(__props) {
    const jwtToken = ref('');
    const algorithm = ref('HS256');
    const header = ref({});
    const payload = ref({});
    const secret = ref('bejson');
    // const timestamp = ref('')
    // const convertedTime = ref('')
    const message = ref('');
    const messageType = ref('info');
    const encodeJWT = async () => {
      try {
        const secretKey = new TextEncoder().encode(secret.value);
        const jwt = await new SignJWT(payload.value).setProtectedHeader({
          alg: algorithm.value,
          typ: 'JWT',
          kid: header.value.kid
        }).setIssuedAt().sign(secretKey);
        jwtToken.value = jwt;
        showMessage('编码成功', 'success');
      } catch (error) {
        showMessage(`编码失败: ${error.message}`, 'error');
      }
    };

    // const decodeJWT = () => {
    //   try {
    //     const decoded = jwtDecode(jwtToken.value, { header: true })
    //     debugger
    //     header.value = decoded.header
    //     payload.value = decoded.payload
    //     showMessage('解码成功', 'success')
    //   } catch (error) {
    //     showMessage(`解码失败: ${error.message}`, 'error')
    //   }
    // }

    const verifyJWT = async () => {
      try {
        const decoded = jwtDecode(jwtToken.value, {
          complete: true
        });
        // const headervalue = jwtDecode(jwtToken.value, { header: true })
        const now = Math.floor(Date.now() / 1000);
        if (decoded.exp && decoded.exp < now) {
          throw new Error('Token已过期');
        }
        if (decoded.nbf && decoded.nbf > now) {
          throw new Error('Token尚未生效');
        }
        showMessage('校验通过', 'success');
      } catch (error) {
        showMessage(`校验失败: ${error.message}`, 'error');
      }
    };

    // const convertTime = () => {
    //   const date = new Date(parseInt(timestamp.value) * 1000)
    //   convertedTime.value = date.toLocaleString()
    // }

    const showMessage = (text, type) => {
      message.value = text;
      messageType.value = type;
      setTimeout(() => message.value = '', 3000);
    };

    // 新增功能方法
    const generateRandomHeader = () => {
      const algorithms = ['HS256', 'HS384', 'HS512'];
      header.value = {
        alg: algorithms[Math.floor(Math.random() * algorithms.length)],
        typ: 'JWT',
        kid: generateRandomString(8)
      };
    };
    const generateRandomPayload = () => {
      payload.value = {
        sub: `user_${generateRandomString(4)}`,
        name: `User ${Math.floor(Math.random() * 1000)}`,
        iat: Math.floor(Date.now() / 1000),
        exp: Math.floor(Date.now() / 1000) + 3600,
        jti: generateRandomString(16)
      };
    };
    const generateRandomSecret = () => {
      const length = algorithm.value === 'HS256' ? 32 : algorithm.value === 'HS384' ? 48 : 64;
      secret.value = generateRandomString(length);
    };
    const generateRandomString = length => {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
      return Array.from(crypto.getRandomValues(new Uint8Array(length))).map(byte => chars[byte % chars.length]).join('');
    };
    const copyToClipboard = async content => {
      try {
        await navigator.clipboard.writeText(JSON.stringify(content, null, 2));
        showMessage('复制成功', 'success');
      } catch (error) {
        showMessage('复制失败', 'error');
      }
    };

    // 优化解码错误处理
    const decodeJWT = () => {
      try {
        if (!jwtToken.value) throw new Error('Token不能为空');
        const [headerPart, payloadPart] = jwtToken.value.split('.');
        if (!headerPart || !payloadPart) throw new Error('无效的Token格式');
        const headerValue = jwtDecode(jwtToken.value, {
          header: true
        });
        const decoded = jwtDecode(jwtToken.value, {
          complete: true
        });

        // 验证时间有效性
        const now = Math.floor(Date.now() / 1000);
        if (decoded.exp && decoded.exp < now) {
          throw new Error('Token已过期');
        }
        if (decoded.nbf && decoded.nbf > now) {
          throw new Error('Token尚未生效');
        }
        header.value = headerValue;
        payload.value = decoded;
        showMessage('解码成功', 'success');
      } catch (error) {
        let message = `解码失败: ${error.message}`;
        if (error.name === 'InvalidTokenError') {
          message += ' (Token结构错误)';
        }
        showMessage(message, 'error');
        header.value = {};
        payload.value = {};
      }
    };

    // 计算属性格式化显示
    const formattedHeader = computed(() => JSON.stringify(header.value, null, 2));
    const formattedPayload = computed(() => JSON.stringify(payload.value, null, 2));
    return (_ctx, _cache) => {
      const _component_Grid = _resolveComponent("Grid");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_CopyDocument = _resolveComponent("CopyDocument");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => jwtToken.value = $event),
        class: "token-input",
        placeholder: "输入或粘贴JWT Token"
      }, null, 512), [[_vModelText, jwtToken.value]])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => algorithm.value = $event)
      }, _hoisted_11, 512), [[_vModelSelect, algorithm.value]])]), _createElementVNode("div", {
        class: "button-group"
      }, [_createElementVNode("button", {
        onClick: encodeJWT,
        class: "action-btn encode-btn"
      }, " ← 编码 "), _createElementVNode("button", {
        onClick: decodeJWT,
        class: "action-btn decode-btn"
      }, " → 解码 "), _createElementVNode("button", {
        onClick: verifyJWT,
        class: "action-btn verify-btn"
      }, " ◆ 校验 ")])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("button", {
        onClick: generateRandomHeader,
        class: "icon-btn"
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Grid)]),
        _: 1
      })]), _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = $event => copyToClipboard(header.value)),
        class: "icon-btn"
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
        _: 1
      })])])]), _createElementVNode("pre", null, _toDisplayString(formattedHeader.value), 1)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [_createElementVNode("button", {
        onClick: generateRandomPayload,
        class: "icon-btn"
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Grid)]),
        _: 1
      })]), _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = $event => copyToClipboard(payload.value)),
        class: "icon-btn"
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
        _: 1
      })])])]), _createElementVNode("pre", null, _toDisplayString(formattedPayload.value), 1)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", {
        class: "secret-header"
      }, [_hoisted_24, _createElementVNode("button", {
        onClick: generateRandomSecret,
        class: "generate-btn"
      }, " 随机生成 ")]), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => secret.value = $event),
        placeholder: "输入密钥"
      }, null, 512), [[_vModelText, secret.value]])])])]), message.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['message', messageType.value])
      }, _toDisplayString(message.value), 3)) : _createCommentVNode("", true)]);
    };
  }
};